var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRecentItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kw5n6d10se",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.828%",
    stopColor: "#FFF",
    stopOpacity: 0.877
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tycmxmgtlf",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.593%",
    stopColor: "#FFF",
    stopOpacity: 0.752
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "06lsb6euwh",
    x1: "91.791%",
    x2: "32.368%",
    y1: "16.518%",
    y2: "92.788%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A3B4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#596BD4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "v3ddth0dmb",
    d: "M0 0H480V1007H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kq0o8ovpng",
    d: "M0 0.046L35.735 0.046 35.735 33.104 0 33.104z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "0gpweiwdna",
    width: "105.6%",
    height: "102.7%",
    x: "-2.2%",
    y: "-1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.874509804 0 0 0 0 0.878431373 0 0 0 0 0.921568627 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "336uae7iwc",
    cx: 51,
    cy: 51,
    r: 51
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-192 -265)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#0gpweiwdna)",
    xlinkHref: "#v3ddth0dmb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#v3ddth0dmb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-192 -265) translate(192 265)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4x46a0ojfd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#336uae7iwc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EDF2FF",
    xlinkHref: "#336uae7iwc"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#4x46a0ojfd)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#kw5n6d10se)",
    d: "M70 21C70 9.402 79.39 0 90.971 0c7.134 0 13.435 3.566 17.224 9.016 1.298-.45 2.692-.695 4.143-.695C119.331 8.32 125 13.997 125 21",
    transform: "translate(-14 6) matrix(-1 0 0 1 195 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tycmxmgtlf)",
    d: "M0 81c0-11.598 9.39-21 20.971-21 7.134 0 13.435 3.566 17.224 9.016 1.298-.45 2.692-.695 4.143-.695C49.331 68.32 55 73.997 55 81",
    transform: "translate(-14 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 6) translate(42 27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w2co1hdm0i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kq0o8ovpng"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#06lsb6euwh)",
    d: "M35.735 6.205c-.31-1.946-2.005-3.38-3.999-3.38H17.401c-1.066 0-2.031-.623-2.462-1.587-.324-.724-1.05-1.192-1.85-1.192H2.482C1.645.046.895.556.594 1.328.07 2.675-.11 4.128.065 5.561L3.24 31.245c.036.295.212.554.473.7l1.856 1.038c.142.08.302.12.466.12H32.37c.488 0 .895-.367.94-.847l2.425-26.051",
    mask: "url(#w2co1hdm0i)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BBC5FF",
    d: "M8.684 9.74c.212-2.215 2.055-3.907 4.259-3.907l29.024.502c1.896.033 3.362 1.69 3.182 3.597L43.162 30.98C42.9 33.271 40.98 35 38.697 35l-32.694-.217c-1.41-.01-2.572-1.122-2.658-2.545l.88.136c.592.091 1.193-.102 1.624-.52.49-.478.796-1.116.863-1.8L8.684 9.741z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#596BD4",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M23.418 24.167c1.046.555 2.3.833 3.764.833 1.463 0 2.718-.278 3.763-.833"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.164,
    cy: 17.083,
    fill: "#596BD4",
    rx: 1.255,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.527,
    cy: 17.083,
    fill: "#596BD4",
    rx: 1.255,
    ry: 1.25
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecentItem);
export default __webpack_public_path__ + "ECMv6/static/media/no-recent-item.bafa93ea1cf88f0b3b0a1f0954fd0124.svg";
export { ForwardRef as ReactComponent };